import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
import DatePickerLayout from './DatePicker';

const SearchFilter = ({
  setDateFrom,
  setDateTo,
  setSearchTitle,
  dateTo,
  dateFrom,
  isTitleVisible,
  handleSearch,
  handlePrint,
  handleOnExport,
  heading,
  isApplicantName,
  setApplicantName,
  setSelectapplicantName,
  type,
  applicantName,
  isCampaign,
  setselectcampaignName,
  campaignName,
  isPayment,
  setDate,
  date,
  apiData,
  isAmount,
}) => {
  const { t } = useTranslation();
  const todayDate = new Date();

  return (
    <div className="col-lg-11">
      <div className="shadow-md  rounded-md">
        <div className="card-header p-2 text-center">
          <h1 className="font-bold sm:text-2xl text-center text-xl text-customgreen">{t(`${heading}`)}</h1>
        </div>
        <div className="card-body p-10">
          {isPayment ? (
            <div className="row">
              <div className={'col-lg-6 my-2'}>
                <label>{t('Project Name')}</label>
                <input
                  type="text"
                  className=" border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5"
                  onChange={(e) => setSearchTitle(e.target.value)}
                />
              </div>
              <div className="col-lg-6 ">
                <DatePickerLayout
                  label={'Date'}
                  selectedDate={date}
                  keyValue={'from'}
                  maxDate={todayDate}
                  dateFrom={date}
                  setDateFrom={setDate}
                />
              </div>
              <div className="col-lg-12">
                <div className="form-group px-6 pt-7 text-center">
                  <button
                    className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                    onClick={handleSearch}
                  >
                    {t('Search')}
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="row">
                {isTitleVisible && (
                  <div className={`${isApplicantName ? 'col-lg-6' : 'col-lg-12'} my-2`}>
                    <label>{t('Title')}</label>
                    <input
                      type="text"
                      className=" border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5"
                      onChange={(e) => setSearchTitle(e.target.value)}
                    />
                  </div>
                )}
                {isApplicantName && (
                  <div className={`col-lg-6 my-2`}>
                    <label>{t('Applicant Name')}</label>
                    <input
                      type="text"
                      className=" border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5"
                      onChange={(e) => setApplicantName(e.target.value)}
                    />
                  </div>
                )}
              </div>

              <div className="row">
                {type !== 'reportList' ? (
                  <>
                    <div className="col-lg-6  my-2">
                      <DatePickerLayout
                        label={'Date From'}
                        selectedDate={dateFrom}
                        keyValue={'from'}
                        maxDate={todayDate}
                        dateFrom={dateFrom}
                        setDateFrom={setDateFrom}
                      />
                    </div>
                    <div className="col-lg-6  my-2">
                      <DatePickerLayout
                        label={'Date To'}
                        selectedDate={dateTo}
                        keyValue={'to'}
                        minDate={dateFrom}
                        maxDate={todayDate}
                        dateTo={dateTo}
                        setDateTo={setDateTo}
                      />
                    </div>
                    {/* <div className="col-lg-12">
                  <div className="form-group px-6 pt-7 text-center">
                    <button
                      className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                      onClick={handleSearch}
                    >
                      {t('Search')}
                    </button>
                  </div>
                </div> */}
                  </>
                ) : (
                  <>
                    <div className={`col-lg-${type == 'reportList' ? '12' : '6'} my-2`}>
                      <label>{t('Applicant Name')}</label>
                      <select
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5"
                        onChange={(e) => setSelectapplicantName(e.target.value)}
                      >
                        <option value="">{t('All')}</option>
                        {applicantName?.map((data, index) => (
                          <option key={index} value={data?.userName}>
                            {data?.userName}
                          </option>
                        ))}
                      </select>
                    </div>
                    {isCampaign && (
                      <div className={`col-lg-${type == 'reportList' ? '12' : '6'} my-2`}>
                        <label>{t('Campaign Name')}</label>
                        <select
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5"
                          onChange={(e) => setselectcampaignName(e.target.value)}
                        >
                          <option value="">{t('All')}</option>
                          {campaignName?.map((data, index) => (
                            <option key={index} value={data?.campaignName}>
                              {data?.campaignName}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                  </>
                )}
                <div className="col-lg-12">
                  <div className="form-group px-6 pt-7 text-center">
                    <button
                      className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                      onClick={handleSearch}
                    >
                      {t('Search')}
                    </button>
                  </div>
                </div>
              </div>
            </>
          )}
          {isAmount && (
            <div className=" text-center py-2 mt-2">
              <span className="font-bold text-customgreen">{`${t('Total Amount')}: ${apiData?.totalAmount ? apiData?.totalAmount : 0}  ${t('AED')}`}</span>
            </div>
          )}
          <div className="col-lg-12 flex justify-center md:justify-end gap-2 mt-5">
            <div className="flex justify-center md:flex-row md:justify-end gap-2">
              <button
                className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                onClick={handlePrint}
              >
                {<span>{t('Print')}</span>}
              </button>
            </div>
            <div className="flex justify-center md:flex-row md:justify-end gap-2">
              <button
                className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                onClick={handleOnExport}
              >
                {t('Export')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchFilter;
